"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomChar = void 0;
var numbers_1 = require("../numbers");
var getRandomChar = function () {
    var characters = 'abcdefghijklmnopqrstuvwxyz';
    return characters.charAt((0, numbers_1.getRandomInt)(characters.length - 1));
};
exports.getRandomChar = getRandomChar;
//# sourceMappingURL=getRandomChar.js.map